module.exports = __webpack_public_path__ + "img/prop-hero-section.8d1a6f93.jpg";